module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"F.A.Q."},"zh":{"title":"F.A.Q."},"kr":{"title":"F.A.Q."}}')
  delete Component.options._Ctor
}
